// @ts-nocheck
// @ts-ignore
// @ts-ignore
import { useEffect, useMemo, useRef, useState } from 'react';
import styles from './style.module.css'
import { useParams } from 'react-router-dom';
// @ts-ignore
import { URL } from '../../Settings';
import axios from 'axios';


const sourceUrl = "https://api.view.nuvola.co.il/"
export default function MediaPlayer({ type, building, floorId, ads, media }) {


    const currentMedia = useRef(-1);
    const currentAd = useRef(-1);
    const mediaCount = useRef(0);
    const adCount = useRef(0);
    const timeout = useRef(null);
    const playTimeout = useRef(null);
    const startMedia = useRef(true);

    const mute = useMemo(() => type !== 3, []);
    const { buildingId } = useParams();
    const { AdAntecedent, AdConsequent } = building ? building : { AdConsequent: 1, AdAntecedent: 5 }
    const currentElementType = useRef("");
    const [currentElement, setCurrentElement] = useState(null);

    useEffect(() => {
        startMedia.current = true;
        currentMedia.current = -1;
        currentAd.current = -1;
        mediaCount.current = 0;
        adCount.current = 0;
        
        return () => {
            clearTimeout(timeout.current);
            clearTimeout(playTimeout.current);
        };
    }, [])

    useEffect(() => {
        if (media.length > 0 || ads.length > 0) {
            PlayNext();
        }
        return () => {
            clearTimeout(timeout.current);
            clearTimeout(playTimeout.current);
        };
    }, [media.length, ads.length])


    function PlayNext() {

        //console.log("Media", mediaCount.current, "Ads", adCount.current)
        clearTimeout(timeout.current);
        clearTimeout(playTimeout.current);
        if (media.length === 0 && ads.length === 0)
            return;
        else if ((ads.length == 0 || AdConsequent <= 0) && media.length > 0) {
            StartNextMedia();
        } else if (AdAntecedent > 0 && mediaCount.current < AdAntecedent && media.length > 0 && mediaCount.current > 0) {
            StartNextMedia();
        } else if (AdConsequent > 0 && adCount.current < AdConsequent && ads.length > 0 && adCount.current > 0) {
            StartNextAd();
        } else if (AdAntecedent == mediaCount.current && ads.length > 0) {
            mediaCount.current = 0;
            StartNextAd();
        } else if (AdConsequent == adCount.current && media.length > 0) {
            adCount.current = 0
            StartNextMedia();
        } else if (mediaCount.current == 0 && adCount.current == 0 && AdAntecedent > 0 && media.length > 0) {
            StartNextMedia();
        } else if (mediaCount.current == 0 && adCount.current == 0 && AdConsequent > 0 && ads.length > 0) {
            StartNextAd();
        } else {
            //console.log("play nothing")
        }
    }


    function StartNextMedia() {
        if (media.length > 0) {
            if (type === 1 && media.length === 1 && currentMedia.current === 0) {
                return;
            }

            if (type === 1) {
                // For type 1 only change index without Stop
                currentMedia.current = (currentMedia.current + 1) >= media.length ? 0 : currentMedia.current + 1;
                let element = media[currentMedia.current]
                element.duration = element.Duration || "00:00:10";
                element.format = element.Type == 1 ? "image" : (element.Type == 4 ? "video" : "youtube");
                
                const durArr = element.duration.split(':');
                var durInSecs = (Number(durArr[0]) * 60 * 60 + Number(durArr[1]) * 60 + Number(durArr[2]));
                var durInMilliSecs = (durInSecs * 1000) + 1000;
                
                currentElementType.current = "media";
                setCurrentElement(currentMedia.current);
                
                // Play video if needed
                if (element.format === "video") {
                    const tryPlayVideo = (attempts = 3) => {
                        setTimeout(() => {
                            const videoEl = document.getElementById(`media-${type}-${currentMedia.current}`);
                            if (videoEl && currentMedia.current === media.indexOf(element)) {
                                videoEl.onended = () => {
                                    PlayNext();
                                };
                                videoEl.play().catch(err => {
                                    if (attempts > 1) {
                                        tryPlayVideo(attempts - 1);
                                    } else {
                                        // If all attempts failed, move to next media
                                        PlayNext();
                                    }
                                });
                            }
                        }, 100);
                    };
                    tryPlayVideo();
                } else if (element.format === "youtube") {
                    // For YouTube use set time as YouTube API doesn't work in iframe
                    timeout.current = window.setTimeout(function () {
                        mediaCount.current = mediaCount.current + 1;
                        PlayNext();
                    }, (durInMilliSecs));
                    return;
                }
                
                if (media.length === 1) {
                    return;
                }
                
                // Don't set timeout for videos as they will move on onended
                if (element.format !== "video") {
                    timeout.current = window.setTimeout(function () {
                        mediaCount.current = mediaCount.current + 1;
                        PlayNext();
                    }, (durInMilliSecs));
                }
            } else {
                StopCurrent();
                currentMedia.current = (currentMedia.current + 1) >= media.length ? 0 : currentMedia.current + 1;
                let element = media[currentMedia.current]
                const id = `media-${type}-${currentMedia.current}`
                element.duration = element.Duration || "00:00:10";
                element.format = element.Type == 1 ? "image" : (element.Type == 4 ? "video" : "youtube");

                const durArr = element.duration.split(':');
                var durInSecs = (Number(durArr[0]) * 60 * 60 + Number(durArr[1]) * 60 + Number(durArr[2]));
                var durInMilliSecs = (durInSecs * 1000) + 1000;

                if (type === 3)
                    console.log(`Total Media ${media.length}, Current Index ${currentMedia.current}, Duration: ${element.duration}, Calculated Seconds: ${durInSecs}, Schedule to Change: ${durInMilliSecs / 1000} seconds`)
                currentElementType.current = "media";
                setCurrentElement(currentMedia.current);

                if (startMedia.current && element.format == "youtube") {
                    startMedia.current = false;
                    playTimeout.current = window.setTimeout(function () {
                        Play(id);
                    }, 3000);
                } else {
                    playTimeout.current = window.setTimeout(function () {
                        Play(id);
                    }, 2000);
                }

                timeout.current = window.setTimeout(function () {
                    mediaCount.current = mediaCount.current + 1;
                    PlayNext();
                }, (durInMilliSecs));
            }
        }
    }
    function StartNextAd() {
        if (ads.length > 0) {

            StopCurrent();
            currentAd.current = (currentAd.current + 1) % ads.length;

            let element = ads[currentAd.current]
            const id = `media-ads-${type}-${currentAd.current}`
            element.duration = element.Duration || "00:00:10";
            element.format = element.Type == 1 ? "image" : (element.Type == 4 ? "video" : "youtube");

            const durArr = element.duration.split(':');
            var durInSecs = (Number(durArr[0]) * 60 * 60 + Number(durArr[1]) * 60 + Number(durArr[2]));
            var durInMilliSecs = durInSecs * 1000;

            currentElementType.current = "ads";
            setCurrentElement(currentAd.current);

            if (startMedia.current && element.format == "youtube") {
                startMedia.current = false;
                playTimeout.current = window.setTimeout(function () {
                    Play(id);
                }, 3000);
            } else {
                playTimeout.current = window.setTimeout(function () {
                    Play(id);
                }, 2000);
            }

            timeout.current = window.setTimeout(function () {
                adCount.current = adCount.current + 1;
                UpdateAdCount(element.Id, durInSecs);
                PlayNext();
            }, (durInMilliSecs + 2000));
        }
    }
    function UpdateAdCount(id, duration) {
        // @ts-ignore
        axios.post(`${sourceUrl}/api/ads/count?adId=${id}&floorId=${floorId.current}&seconds=${duration}`, null, { headers: { Secret: 'Maxim1221' } }).then(res => {
            //if (res.data === "Succeeded")
            //console.log(`Updated ad count with Id ${id}, Seconds ${duration}`)
        })
    }


    function StopCurrent() {
        clearTimeout(timeout.current);
        clearTimeout(playTimeout.current);
        setCurrentElement(null);
        currentElementType.current = "";
        Stop(`media-${type}-${currentMedia.current}`)
        Stop(`media-ads-${type}-${currentAd.current}`)
    }

    function resizePlayer(ratio) {

        var win = document.getElementById(`media-${type}`);
        if (!win)
            return 0;
        var width = win.clientWidth,
            playerWidth,
            height = win.clientHeight,
            // @ts-ignore
            playerHeight,
            // @ts-ignore
            ratio = ratio || 16 / 9;
        // @ts-ignore
        var iframs = win.getElementsByTagName("iframe");


        if (width / ratio < height) {
            playerWidth = Math.ceil(height * ratio);
            return playerWidth;
        } else {
            return '100%'
        }
    }
    function postMessageToPlayer(player, command) {
        if (player == null || command == null) return;
        player.contentWindow.postMessage(JSON.stringify(command), "*")

    }

    function Stop(currentId) {
        const currentEle = document.getElementById(currentId);
        if (currentEle) {
            currentEle.style.display = "none";
            //console.log(currentId, 'stop')
            if (currentEle.nodeName === "VIDEO") {
                // @ts-ignore
                currentEle.pause();
                // @ts-ignore
                currentEle.currentTime = 0;
                // @ts-ignore
                currentEle.src = '';
                // @ts-ignore
                currentEle.load();
            } else if (currentEle.nodeName === "IFRAME") {
                postMessageToPlayer(currentEle, {
                    "event": "command",
                    "func": "stopVideo"
                });
            }
        }
    }
    function Play(currentId) {
        const currentEle = document.getElementById(currentId);
        if (currentEle) {
            //console.log(currentId, 'play')
            currentEle.style.display = "unset";
            if (currentEle.nodeName === "VIDEO") {
                // @ts-ignore
                currentEle.play();
            } else if (currentEle.nodeName === "IFRAME") {
                postMessageToPlayer(currentEle, {
                    "event": "command",
                    "func": "mute"
                });
                postMessageToPlayer(currentEle, {
                    "event": "command",
                    "func": "playVideo"
                });
                if (!mute) {
                    postMessageToPlayer(currentEle, {
                        "event": "command",
                        "func": "unMute"
                    });
                }
            }
        }
    }


    const render = useMemo(() => {
        if (type === 1) {
            return (
                <div style={{ position: 'relative', width: '100%', height: '100%' }}>
                    {media.map((element, index) => {
                        const id = `media-${type}-${index}`;
                        element.href = element.Value || null;
                        element.format = element.Type == 1 ? "image" : (element.Type == 4 ? "video" : "youtube");
                        
                        if (element.format == "image") {
                            return (
                                <img 
                                    key={index}
                                    className={styles.img} 
                                    id={id} 
                                    src={`${sourceUrl}Resources/element_image/${buildingId}/${element.href}`} 
                                    style={{ 
                                        position: 'absolute',
                                        top: 0,
                                        left: 0,
                                        width: '100%',
                                        height: '100%',
                                        objectFit: 'contain',
                                        opacity: currentElement === index && currentElementType.current === "media" ? 1 : 0,
                                        transition: 'opacity 1s ease-in-out'
                                    }} 
                                />
                            );
                        } else if (element.format == "video") {
                            return (
                                <video 
                                    key={index}
                                    id={id} 
                                    style={{ 
                                        position: 'absolute',
                                        top: 0,
                                        left: 0,
                                        width: '100%',
                                        height: '100%',
                                        objectFit: 'contain',
                                        opacity: currentElement === index && currentElementType.current === "media" ? 1 : 0,
                                        transition: 'opacity 1s ease-in-out'
                                    }} 
                                    muted
                                    autoPlay
                                    loop={media.length === 1}
                                >
                                    <source src={element.href} type="video/mp4" />
                                </video>
                            );
                        } else if (element.format == "youtube") {
                            return (
                                <iframe 
                                    key={`${index}-${currentElement}`}
                                    id={id} 
                                    src={currentElement === index && currentElementType.current === "media" ? `${element.href}?enablejsapi=1&autoplay=1&mute=1&start=0` : 'about:blank'}
                                    style={{ 
                                        position: 'absolute',
                                        top: 0,
                                        left: 0,
                                        width: '100%',
                                        height: '100%',
                                        opacity: currentElement === index && currentElementType.current === "media" ? 1 : 0,
                                        transition: 'opacity 1s ease-in-out'
                                    }} 
                                    frameBorder="0" 
                                    allow="autoplay; encrypted-media"
                                />
                            );
                        }
                        return null;
                    })}
                </div>
            );
        }

        if (currentElement == null || currentElementType.current == "")
            return null;
        const element = currentElementType.current == "media" ? media[currentElement] : (currentElementType.current == "ads" ? ads[currentElement] : null)
        if (!element)
            return null;

        var date = new Date();
        if (type === 3) {
            console.log(`Playing Music: ${element.Value}, Duration: ${element.Duration},  Time: ${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}`,);
        }
        const id = `${currentElementType.current == "media" ? "media" : "media-ads-"}-${type}-${currentElement}`
        element.href = element.Value || null;
        element.format = element.Type == 1 ? "image" : (element.Type == 4 ? "video" : "youtube");

        if (element.format == "youtube") {
            var href = element.href.split('&');
            element.href = href[0];
        }
        if (element.format == "image") {
            return <img className={styles.img} id={id} src={`${sourceUrl}Resources/element_image/${buildingId}/${element.href}`} />
        }
        else if (element.format == "video") {
            return <video id={id} style={{ width: 'auto', objectFit: "cover", height: '100%' }} preload="auto" muted={mute} autoPlay={true} loop><source src={element.href} type="video/mp4" /></video>
        }
        return <iframe id={id} style={{ height: '100%', minWidth: resizePlayer(16 / 9) }} className='iframe_youtube embed-player slide-media' src={`${element.href}?enablejsapi=1&controls=0&fs=0&iv_load_policy=3&rel=0&showinfo=0&loop=1&start=1`} allow="autoplay"></iframe>

    }, [currentElement])


    return <div id={`media-${type}`} className={styles.media_slides}>{render}</div>;
}